import { render, staticRenderFns } from "./ComplexionEffect.vue?vue&type=template&id=1f358dba&scoped=true&"
import script from "./ComplexionEffect.vue?vue&type=script&lang=js&"
export * from "./ComplexionEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f358dba",
  null
  
)

export default component.exports